import React from "react";
import { Form } from "components/form";
import { InputText } from "components/input";
import { Button } from "components/button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export const FormRegEmail = () => (
  <Form className="form mt-3">
    <div className="row mb-4">
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Popover id="popover-basic">
            <Popover.Body>
              Необходимо указать личный, а не рабочий e-mail
            </Popover.Body>
          </Popover>
        }
      >
        <div className="col-12 col-sm-12 mb-2 mb-sm-3">
          <InputText
            label="Личный e-mail*"
            name="email"
            placeholder="Введи личный e-mail"
            role="formRegEmail"
          />
          <div className="form__text mt-2">
            <p>
              Укажите личный e-mail — мы отправим на него код активации. Его
              нужно будет ввести на следующем шаге регистрации.
            </p>
          </div>
        </div>
      </OverlayTrigger>
    </div>

    <div className="form-reg__footer">
      <Button type="submit" role="formRegSubmitButton">
        Зарегистрироваться
      </Button>
    </div>
  </Form>
);
